import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import withStyles from "@material-ui/core/styles/withStyles";

import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import studentRoutes from "routes/studentRoutes.jsx";
import { useAuth } from "context/AuthContext";

import sidebarBg from "assets/img/sidebar-3.jpg";
import logo from "assets/img/favicon.png";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";

const switchRoutes = (
  <Switch>
    {studentRoutes.map((prop, key) => {
      if (prop.redirect) return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
      return <Route exact path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

var ps;

class PortalLayoutInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mobileOpen: false, miniActive: false };
    this.resizeFunction = this.resizeFunction.bind(this);
  }

  componentDidMount() {
    if (!this.props.auth.user && !this.props.auth.loading) {
      this.props.history.push("/portal/login");
      return;
    }
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true, suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.auth.user && !this.props.auth.loading) {
      this.props.history.push("/portal/login");
    }
    if (prevProps.history.location.pathname !== prevProps.location.pathname) {
      if (this.refs.mainPanel) this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) this.setState({ mobileOpen: false });
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1 && ps) ps.destroy();
    window.removeEventListener("resize", this.resizeFunction);
  }

  handleDrawerToggle = () => this.setState({ mobileOpen: !this.state.mobileOpen });

  sidebarMinimize = () => this.setState({ miniActive: !this.state.miniActive });

  resizeFunction() {
    if (window.innerWidth >= 960) this.setState({ mobileOpen: false });
  }

  render() {
    const { classes, auth, ...rest } = this.props;
    const { miniActive, mobileOpen } = this.state;

    if (auth.loading) return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>Loading…</div>;
    if (!auth.user) return null;
    if (auth.user.role !== "Student") return <Redirect to="/bwillis/dashboard" />;
    if (auth.user.mustChangePassword && this.props.location.pathname !== "/portal/change-password") {
      return <Redirect to="/portal/change-password" />;
    }

    const visibleRoutes = studentRoutes.filter(r => !r.redirect && !r.hidden);

    const mainPanel = classes.mainPanel + " " + cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1
    });

    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={visibleRoutes}
          logoText="Student Portal"
          logo={logo}
          image={sidebarBg}
          handleDrawerToggle={this.handleDrawerToggle}
          open={mobileOpen}
          color="blue"
          bgColor="black"
          miniActive={miniActive}
          currentUser={auth.user}
          onLogout={auth.logout}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize}
            miniActive={miniActive}
            routes={visibleRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
          <Footer fluid />
        </div>
      </div>
    );
  }
}

PortalLayoutInner.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const PortalLayoutStyled = withStyles(appStyle)(PortalLayoutInner);

function PortalLayout(props) {
  const auth = useAuth();
  return <PortalLayoutStyled {...props} auth={auth} />;
}

export default PortalLayout;
